



























































import Vue from 'vue'
import eventModule from '@/store/event'
import dealModule from '@/store/deal'
import Component from 'vue-class-component'
import FFilter from '../common/FFilter.vue'
import { Watch } from 'vue-property-decorator'

@Component({
  name: 'DealFilter',
  components: {
    FFilter
  }
})
export default class DealFilter extends Vue {
  opened = false
  form = {
    categories: {} as Record<string, true>,
    tags: {} as Record<string, true>,
    venues: {} as Record<string, true>
  }

  get saveFormData(): Record<string, string[]> {
    return {
      categories: Object.keys(this.form.categories).map(
        n => this.possibleFilters.categories[n]._id
      ),
      tags: Object.keys(this.form.tags).map(
        n => this.possibleFilters.tags[n]._id
      ),
      venues: Object.keys(this.form.venues).reduce(
        (cum, n) => [...cum, ...this.possibleFilters.venues[n].ids],
        [] as string[]
      )
    }
  }

  @Watch('possibleFilters')
  sanitize() {
    console.log('update possibleFilters')
    // eslint-disable-next-line no-undef
    const newForm: typeof this.form = {
      categories: {},
      tags: {},
      venues: {}
    }
    for (const i in this.possibleFilters) {
      // eslint-disable-next-line no-undef
      const key = i as keyof typeof this.possibleFilters &
        // eslint-disable-next-line no-undef
        keyof typeof this.form
      const value = this.possibleFilters[key]

      for (const formName in this.form[key]) {
        if (value[formName]) {
          newForm[key][formName] = true
        }
      }
    }

    this.form = newForm
    this.save()
  }

  save() {
    eventModule.setFilters(this.saveFormData)
    this.opened = false
  }

  get possibleFilters() {
    return dealModule.possibleFilters
  }

  toSelectItems<T>(obj: Record<string, T>): T[] {
    return Object.values(obj)
  }

  reset() {
    this.form = {
      categories: {},
      tags: {},
      venues: {}
    }
  }
}
